import { ecsApi } from '@services';
import { CreateEventFeedbackPayload, CreateEventFeedbackResponse, GetEventFeedbackTypesResponse } from './eventFeedback.types';

export const eventFeedbackApi = ecsApi.injectEndpoints({
    endpoints: (builder) => ({
        getEventFeedbackTypes: builder.mutation<GetEventFeedbackTypesResponse, void>({
            query: () => ({
                url: '/event-feedbacks/types',
                method: 'GET'
            })
        }),
        createEventFeedback: builder.mutation<CreateEventFeedbackResponse, CreateEventFeedbackPayload>({
            query: (payload) => ({
                url: '/event-feedbacks',
                method: 'POST',
                body: payload
            })
        })
    })
});

export const { useGetEventFeedbackTypesMutation, useCreateEventFeedbackMutation } = eventFeedbackApi;
